import React from 'react'
import PropTypes from 'prop-types'
import ErrorBubble from '../ErrorBubble'

export default class Field extends React.Component {

  static propTypes = {
    validate: PropTypes.bool,
    validity: PropTypes.object,
  }

  state = {
    validate: false,

    /**
     * element.valid property.
     */
    validity: {valid: true}
  }

  field = null

  constructor(props) {
    super(props)

    this.state = {
      ...this.state,
      ...props,
    }
  }

  componentDidMount() {
    if (!this.field) {
      return
    }

    this.inputs = [...this.field.getElementsByTagName('input')]

    for (let input of this.inputs) {
      input.addEventListener('blur', this.onInputBlur)
      input.addEventListener('keypress', this.onInputKeyPress)
    }
  }

  /**
   * Prevent ErrorBubbles from being rendered when field is valid.
   */
  getChildren() {
    return React.Children.map(this.props.children, c => {
      switch (c.type) {
        case ErrorBubble:
          return React.cloneElement(c, {validity: this.state.validity})
        default:
          return c
      }
    })
  }

  onInputKeyPress = (e) => {
    if (!this.state.validate) {
      return
    }

    this.setState({
      validity: e.target.validity
    })
  }

  onInputBlur = (e) => {
    this.setState({validate: true})
  }

  getClassName = () => {
    let className = ['form-field']

    !this.state.validity.valid && className.push('form-field-error')

    return className.join(' ')
  }

  render() {
    return (
      <div ref={ field => this.field = field } className={ this.getClassName() } >
        { this.getChildren() }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/Components/Form/Field/Field.jsx